module.exports = __webpack_public_path__ + "media/images/icon__dropdown--arrow@3x-cd63d2238f67d244eba967f2803b95cb.png";